import { get } from 'lodash';
import * as dealInfoHelpers from '../../utils/deal-info-helpers';
export function isSubscribedTo(channel) {
    return Boolean(get(channel, 'dgsInfo.subscription'));
}
export function isSubscriptionEnabled(channel) {
    return Boolean(dealInfoHelpers.getSubscriptionPriceInfo(channel.dealInfo));
}
export function isPricingPlanEnabled({ dealInfo }) {
    return Boolean(dealInfoHelpers.getPricingPlanInfo(dealInfo));
}
export function getDealInfo(props) {
    return get(props, 'channelData.dealInfo');
}
export function hasAccessToChannelByPricingPlan(channelInfo) {
    return channelInfo.hasAccessToChannelByPricingPlan;
}
export function isSubscriptionWasCancelled(channel) {
    return Boolean(get(channel, 'dgsInfo.subscription.expirationTs'));
}
//# sourceMappingURL=pricing.js.map